import { gtmEvent } from '../../utils/gtmEvents';
const gtmBapComparePaymentsDisplayed = () => {
    const gtmData = {
        event: 'compare_payments_displayed',
    };
    gtmEvent(gtmData);
};
export default gtmBapComparePaymentsDisplayed;
